import orderService from "@/services/OrderService";
import {tableMutations} from "@tt/vue-components";

const returnReasons = {
  namespaced: true,
  state: {
    loading: false,
    reasons: [],
  },
  mutations: {
    ...tableMutations,
    SET_REASONS(state, reasons) {
      state.reasons = reasons;
    }
  },
  actions: {
    fetchReasons(context) {
      const params ={
        search: [{column: "type[]", value: "return"}, {column: "type[]", value: "all"}],
        sorting: { sortBy: ["name"], sortDesc: [false] }
      };

      orderService.reasons.list(params)
          .then(json => {
            context.commit("SET_REASONS", json.items);
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            context.commit("SET_LOADING", false);
          });

    },
  },
  getters: {
    reasonById: (state) => (id) => {
      return state.reasons.find(item => item['@id'] === id)?.name
    }
  }
};

export default returnReasons;
